import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {HomeIndexComponent} from './home-index';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.home-index', {
      url: '/index',
      ncyBreadcrumb: {
        label: 'Home Page'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Home Page'
      },
      views: {
        homeContent: {
          template: '<home-index flex="100"></home-index>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const HomeIndexModule: string = ng
  .module('home-index', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('homeIndex', HomeIndexComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/home-index/home-index.module.ts